import { useMemo } from "react";

import useFeedbackItemSelfHosted from "../config/useFeedbackItemSelfHosted";
import useSupportGroupDropdownSaaS from "../config/useSupportGroupDropdownSaaS";
import useUserDropdownGroup from "../config/useUserDropdownGroup";
import { MainNavigationItem, MainNavigationMenuItem } from "../types";

const useMainNavigationSecondaryItems = (): {
  navigationItems: MainNavigationItem[];
  menuItems: MainNavigationMenuItem[];
  menuItemsMap: Record<string, MainNavigationMenuItem>;
} => {
  const feedbackItemSelfHosted = useFeedbackItemSelfHosted();
  const supportGroupDropdownSaaS = useSupportGroupDropdownSaaS();
  const userDropdownGroup = useUserDropdownGroup();

  return useMemo(() => {
    const navigationItems = [
      feedbackItemSelfHosted,
      supportGroupDropdownSaaS,
      userDropdownGroup,
    ].filter((item) => item !== undefined);

    const menuItems = navigationItems.flatMap((group) => {
      if ("items" in group) {
        return group.items.flatMap((item) => item.items);
      }
      return [group];
    });

    const menuItemsMap = menuItems.reduce<Record<string, MainNavigationMenuItem>>((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});

    return {
      navigationItems,
      menuItems,
      menuItemsMap,
    };
  }, [feedbackItemSelfHosted, supportGroupDropdownSaaS, userDropdownGroup]);
};

export default useMainNavigationSecondaryItems;
